import { Box, Flex, HStack, Text, Tooltip } from "@chakra-ui/react";
import { FiPhone, FiUser } from "react-icons/fi";
import { getCustomerSearchDisplay } from "../utils/customerSearchDisplay";

type Props = {
  customer: any;
};

// Explicit sizes everywhere: the global Text theme defaults to a vw-based
// font size, so any Text without fontSize renders oversized.
const NAME_FONT_SIZE = "13px";
const META_FONT_SIZE = "11px";
const AVATAR_SIZE = "28px";

/**
 * Dropdown row for customer search:
 *   [Avatar] Customer Name
 *            Owner Name
 *            Mobile Number
 *            Association
 */
const CustomerSearchResultItem = ({ customer }: Props) => {
  const {
    name,
    ownerName,
    associationName,
    formattedMobileNumber,
    initials,
    avatarBg,
    avatarColor,
  } = getCustomerSearchDisplay(customer);

  const displayName = name || "-";

  return (
    <Flex align="center" gap={2} w="100%">
      <Flex
        flexShrink={0}
        align="center"
        justify="center"
        w={AVATAR_SIZE}
        h={AVATAR_SIZE}
        borderRadius="full"
        bg={avatarBg}
        color={avatarColor}
        fontSize="10px"
        fontWeight="bold"
        letterSpacing="0.02em"
      >
        {initials}
      </Flex>

      <Box minW={0} flex={1}>
        <Tooltip
          label={displayName}
          hasArrow
          placement="top"
          openDelay={200}
          isDisabled={!name}
        >
          <Text
            fontSize={NAME_FONT_SIZE}
            fontWeight="semibold"
            color="gray.800"
            noOfLines={1}
            lineHeight="1.3"
            cursor={name ? "default" : undefined}
          >
            {displayName}
          </Text>
        </Tooltip>

        {ownerName && (
          <HStack spacing={1} mt="1px" color="gray.600" minW={0}>
            <Box as={FiUser} flexShrink={0} boxSize="10px" />
            <Text fontSize={META_FONT_SIZE} lineHeight="1.3" noOfLines={1}>
              {ownerName}
            </Text>
          </HStack>
        )}

        {formattedMobileNumber && (
          <HStack spacing={1} mt="1px" color="gray.600">
            <Box as={FiPhone} flexShrink={0} boxSize="10px" />
            <Text
              fontSize={META_FONT_SIZE}
              lineHeight="1.3"
              whiteSpace="nowrap"
            >
              {formattedMobileNumber}
            </Text>
          </HStack>
        )}

        {associationName && (
          <Text
            mt="1px"
            fontSize={META_FONT_SIZE}
            color="gray.500"
            noOfLines={1}
            lineHeight="1.3"
          >
            {associationName}
          </Text>
        )}
      </Box>
    </Flex>
  );
};

export default CustomerSearchResultItem;
